// extracted by mini-css-extract-plugin
module.exports = {"container":"Switch_container__2PBtq","disabled":"Switch_disabled__3Gdgj","track":"Switch_track__OPjfs","button":"Switch_button__2tWkf","checked":"Switch_checked__yTaQJ"};